import { render } from "./DataManagement.vue?vue&type=template&id=548f926e&scoped=true&ts=true"
import script from "./DataManagement.ts?vue&type=script&lang=ts"
export * from "./DataManagement.ts?vue&type=script&lang=ts"

import "./DataManagement.scss?vue&type=style&index=0&id=548f926e&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-548f926e"]])

export default __exports__